// common components
import AppWorkspace from '@/agilis/components/AppWorkspace/AppWorkspace.vue'
import AppSelector from '@/agilis/components/AppSelector/AppSelector.vue'
import AppBarMobile from '../AppBarMobile/AppBarMobile.vue'
import AppBar from '@/agilis/components/AppBar/AppBar.vue'
import SplashScreen from '@/agilis/components/SplashScreen/SplashScreen.vue'
import Settings from '@/agilis/components/Settings/Settings.vue'
import About from '@/agilis/components/About/About.vue'
// scrum
import TrackerDataTablePaginated from '@/applications/scrum/components/TrackerDataTable/TrackerDataTablePaginated.vue'
import TrackerDataTableView from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableView/TrackerDataTableView.vue'
import TrackerTabs from '@/applications/scrum/components/TrackerTabs/TrackerTabs.vue'

// sales
import Product2TableMobile from '@/agilis/mobile/Product2TableMobile/ProductTableMobile.vue'
import CustomerTableMobile from '@/agilis/mobile/CustomerTableMobile/CustomerTableMobile.vue'
import CustomerTableItemViewMobile from '@/agilis/mobile/CustomerTableItemViewMobile/CustomerTableItemViewMobile.vue'
import Contact2TableMobile from '@/agilis/mobile/Contact2TableMobile/Contact2TableMobile.vue'
import PriceItemTableMobile from '@/agilis/mobile/PriceItemTableMobile/PriceItemTableMobile.vue'
import PriceItemTableViewMobile from '@/agilis/mobile/PriceItemTableMobile/datatable/PriceItemTableViewMobile.vue'
import PropositionTableMobile
from '@/applications/sales/mobile/PropositionTableMobile/PropositionTableMobile.vue'
import PropositionTableViewMobile from '@/applications/sales/mobile/PropositionTableViewMobile/PropositionTableViewMobile.vue'
import TrackerDataTableItemEdit from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableItemEdit/TrackerDataTableItemEdit.vue'
// mobile
import AppWorkspaceMobile from '@/agilis/mobile/AppWorkspaceMobile/AppWorkspaceMobile.vue'
import AppSelectorMobile from '@/agilis/mobile/AppSelectorMobile/AppSelectorMobile.vue'
import TrackerDataTablePaginatedMobile from '@/agilis/mobile/TrackerDataTableMobile/TrackerDataTablePaginatedMobile.vue'
import TrackerDataTableViewMobile from '@/agilis/mobile/TrackerDataTableViewMobile/TrackerDataTableViewMobile.vue'
import TrackerTabsMobile from '@/agilis/mobile/TrackerTabsMobile/TrackerTabsMobile.vue'
import DataTableV2PaginatedMobile from '@/agilis/mobile/DataTableV2PaginatedMobile/DataTableV2PaginatedMobile.vue'
import DataTableV2ItemViewMobile from '@/agilis/mobile/DataTableV2ItemViewMobile/DataTableV2ItemViewMobile.vue'
import TrackerParentMobile from '@/agilis/mobile/TrackerParentMobile/TrackerParentMobile.vue'
import SplashScreenMobile from '@/agilis/mobile/SplashScreen/SplashScreen.vue'
import SettingsMobile from '@/agilis/mobile/SettingsMobile/SettingsMobile.vue'
import AboutMobile from '@/agilis/mobile/AboutMobile/AboutMobile.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'ComponentResolverMobile',

  props: {
    componentId: String,
    forwardRef: Function,
    componentProps: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    About,
    AboutMobile,
    AppBar,
    AppBarMobile,
    AppSelector,
    AppSelectorMobile,
    AppWorkspace,
    AppWorkspaceMobile,
    Contact2TableMobile,
    CustomerTableMobile,
    PriceItemTableMobile,
    PriceItemTableViewMobile,
    CustomerTableItemViewMobile,
    DataTableV2PaginatedMobile,
    DataTableV2ItemViewMobile,
    Product2TableMobile,
    PropositionTableMobile,
    PropositionTableViewMobile,
    Settings,
    SettingsMobile,
    SplashScreen,
    SplashScreenMobile,
    TrackerParentMobile,
    TrackerDataTablePaginated,
    TrackerDataTablePaginatedMobile,
    TrackerDataTableView,
    TrackerTabs,
    TrackerTabsMobile,
    TrackerDataTableItemEdit,
    TrackerDataTableViewMobile
  },

  data: () => ({
    resolvedComponentId: ''
  }),

  created: function () {
    this.resolvedComponentId = this.resolveMobileComponent()
  },

  mounted: function () {
    if (typeof this.forwardRef === 'function') {
      this.forwardRef(this.$refs.componentResolved)
    }
  },

  methods: {
    /**
    * Finds and returns the mobile component associated to the component id
    */
    resolveMobileComponent () {
      let resolvedComponentId = this.componentId
      let mobileComponentName = ''
      if (this.$attrs.overrideComponentId) {
        resolvedComponentId = this.$attrs.overrideComponentId
      }
      if (this.$isMobile()) {
        mobileComponentName = `${resolvedComponentId}Mobile`
        const allComponents = Object.values(this.$options.components)
        allComponents.filter(component => {
          if (component.name.includes(mobileComponentName)) {
            resolvedComponentId = mobileComponentName
          }
        })
      }
      return resolvedComponentId
    }
  },
  computed: {
    ...mapGetters({
      'applicationId': 'contextStore/applicationId'
    }),
    forwardProps () {
      return {
        ...this.componentProps
      } // add here props that need to be forwarded to the final component
    }
  }
}
